import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components/common/loader";
import { getPolicy, updateTransactionData } from "../../features/product";
import { Button, Modal } from "react-bootstrap";
import { createPayment } from "../../features/payment";
import "./style.css";
import { useTranslation } from "react-i18next";
import { updateProductInquiry } from "../../features/productInquiry";
import { ReactComponent as OmrSymbol } from "../../assets/SVG/omr_symbol.svg";
import { sendPdfMail } from "../../api/productApi";
import { fetchDownloadAndSendPDF } from "../../utils/takafulHelpers";
import { pdfFileName } from "../../config/constants";

const Checkout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { quoteLoader } = useSelector((state) => state.product);
  const existingData = useMemo(() => {
    return location?.state?.existingData || {};
  }, [location?.state]);
  const [product, setProduct] = useState({});
  const [attentionAlert, setAttentionAlert] = useState(false);
  const [processingPolicy, setProcessingPolicy] = useState(false);
  const { quoteData, policyLoader, policyData } = useSelector(
    (state) => state.product
  );
  const {
    PaymentLoader,
    payment,
    status: paymentStatus,
  } = useSelector((state) => state.payment);
  // // console.log(payment, 'payment');
  const { id } = useParams();


  useEffect(() => {
    let product = localStorage.getItem("product_detail")
      ? JSON.parse(localStorage.getItem("product_detail"))
      : {};
    setProduct(product);
  }, [existingData]);

  const proceedToCheckout = async () => {

    if (existingData?.is_ebridge) {
      localStorage.setItem(
        "quoteData",
        JSON.stringify({
          is_ebridge: true,
          targetCode: existingData?.targetCode,
          company_name: existingData?.company_name,
          premium_value: existingData?.premium_value,
        })
      );
    } else {
      localStorage.setItem(
        "quoteData",
        JSON.stringify({
          ...quoteData,
          token: quoteData?.token || "",
          premium_value: quoteData?.premium_value || "",
          insurance_company_product_mapping_id:
            quoteData?.insurance_company_product_mapping_id || "",
          proposal_id: quoteData?.proposal_id || "",
          encoded_ins_token: encodeURIComponent(quoteData?.token) || "",
        })
      );
    }

    let product_name = getProductAndCompanyLabel(
      existingData,
      existingData?.company_id
    );

    console.log("Checkout:: proceedToCheckout :: existingData :: ", {
      existingData,
      product,
    });

    dispatch(
      updateTransactionData({
        business_status: "CHECKOUT",
        payment_status: "unpaid",
        quote_no: existingData?.quoteNo ?? existingData?.quote_no ?? existingData?.quote_id,
        premium_amount: product?.price
          ? product?.price
          : (existingData?.premium_value || existingData?.planData?.premium_value)
            ? existingData?.premium_value || existingData?.planData?.premium_value
            : 0
      })
    )

    try {
      const response = await dispatch(
        createPayment({
          sub_product_id: existingData.travel_dates == null ? "1" : "2",
          company_id: 4,
          plate_no: existingData?.plateNumber,
          plate_char: existingData?.plate_char,
          mobile_no: existingData?.mobile_no,
          travel_from: existingData.travel_dates == null ? null : "Not found",
          travel_to:
            existingData?.planData?.extracted_data?.destination ??
            existingData?.extracted_data?.destination,
          quote_no:
            existingData?.quoteNo ??
            existingData?.quote_no ??
            existingData?.quote_id,
          insurance_company:
            existingData?.planData?.company_name ??
            existingData?.company_name,
          policy_start_date:
            existingData?.planData?.extracted_data?.start_date ??
            existingData?.extracted_data?.destination,
          policy_expiry_date:
            existingData?.planData?.extracted_data?.end_date ?? null,
          device_token_no: "",
          chassis_no: existingData?.chassis_no,
          engine_no: existingData?.engineNo,
          client_customer_id: "user@yopmail.com",
          products: [
            {
              name: product_name
                ?.replace(/[^a-zA-Z0-9\s-]/g, "")
                ?.substring(0, 40),
              quantity: 1,
              unit_amount: product?.price
                ? parseFloat((product?.price * 1000).toFixed(3))
                : existingData?.premium_value ||
                  existingData?.planData?.premium_value
                  ? parseFloat(
                    (
                      (existingData?.premium_value ||
                        existingData?.planData?.premium_value) * 1000
                    ).toFixed(3)
                  )
                  : 0,
            },
          ],
          success_url: process.env.REACT_APP_URL + "checkout/success",
          cancel_url: process.env.REACT_APP_URL + "checkout/fail",
          metadata: {
            "Customer name": "mamman insurance portal",
            "order id": 0,
          },
        })
      ).unwrap();   // 🔥 IMPORTANT

      console.log("Payment Success:", response);

    } catch (error) {
      console.error("Payment API Error:", error);

      if (error?.status === 500) {
        toast.error("Server error. Please try again later.");
      } else if (error?.status === 400) {
        toast.error("Invalid request. Please check details.");
      } else {
        toast.error(error?.message || "Something went wrong.");
      }
    }
  };

  const sanitizeBase64 = (base64String) => {
    if (typeof base64String !== "string") return base64String;
    let sanitized = base64String.replace(/^data:application\/pdf;base64,/, "");

    // Handle OQIC case: if it starts with HTTP response (base64 of "HTTP/" is "SFRUUC8")
    if (sanitized.startsWith("SFRUUC8")) {
      try {
        const decoded = atob(sanitized);
        const pdfStart = decoded.indexOf("%PDF-");
        if (pdfStart !== -1) {
          sanitized = btoa(decoded.substring(pdfStart));
        }
      } catch (e) {
        console.error("Error unshelving OQIC PDF content:", e);
      }
    }
    return sanitized;
  };

  const handleSendPdfMail = async (email) => {

    console.log("Came to this ", policyData?.pdfContent);

    if (
      policyData &&
      policyData?.pdfContent &&
      policyData?.pdfContent?.document &&
      policyData?.pdfContent?.document?.content !== ""
    ) {
      dispatch(
        sendPdfMail({
          transaction_id: localStorage.getItem("transactionId"),
          mail: email,
          pdf_base64: sanitizeBase64(policyData?.pdfContent?.document?.content), // ✅ BODY, not URL
        })
      );
    } else if (
      policyData &&
      policyData?.pdfContent &&
      policyData?.pdfContent !== ""
    ) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;

      if (urlRegex.test(policyData?.pdfContent)) {
        console.log("Fetching URL content:", policyData?.pdfContent);
        await fetchDownloadAndSendPDF(
          policyData.pdfContent,
          policyData.token,
          (base64Pdf) => {
            dispatch(
              sendPdfMail({
                transaction_id: localStorage.getItem("transactionId"),
                mail: email,
                pdf_base64: sanitizeBase64(base64Pdf),
              })
            );
          }
        );
      } else {
        const { content } = policyData?.pdfContent || {};
        dispatch(
          sendPdfMail({
            transaction_id: localStorage.getItem("transactionId"),
            mail: email,
            pdf_base64: sanitizeBase64(content || policyData?.pdfContent),
          })
        );
      }
    }
    // const emailId = existingFormData.email;



    //  downloadPdf({
    //       name: file_name,
    //       mimeType: "application/pdf",
    //       content: policyData?.pdfContent,
    //     }).then(() => {
    //       dispatch(resetData());
    //       navigate("/");
    //     });

  };


  useEffect(() => {
    if (payment && payment?.url) {
      window.open(payment?.url, "_self");
    }
  }, [paymentStatus, payment]);

  useEffect(() => {
    console.log("Checkout:: UseEffect :: id :: ", id);
    if (id === "success") {
      let quoteData = localStorage.getItem("quoteData")
        ? JSON.parse(localStorage.getItem("quoteData"))
        : null;

      console.log("quoteData :: ", { quoteData });
      if (quoteData) {
        if (quoteData.is_ebridge) {
          dispatch(
            updateTransactionData({
              business_status: "PURCHASED",
              payment_status: "success",
            })
          );
          localStorage.removeItem("quoteData");
          localStorage.removeItem("product_inquiry");
          navigate("/policy-download", {
            state: {
              is_ebridge: true,
              company_name: quoteData.company_name,
              premium_value: quoteData.premium_value,
              premium_currency: "OMR",
            },
          });
        } else {
          setProcessingPolicy(true);
          dispatch(getPolicy(quoteData));
        }
      }
    } else if (id === "fail") {
      toast.error("Payment failed. Please try again.");
      localStorage.removeItem("quoteData");
      localStorage.removeItem("product_inquiry");
    }
  }, [dispatch, id]);

  useEffect(() => {
    console.log("Checkout:: UseEffect :: policyData :: ", policyData, " policyLoader :: ", policyLoader);
    if (policyData && !policyLoader) {

      const pData = Array.isArray(policyData) ? policyData[0] : policyData;
      const fData = pData?.data || pData?.api_response || pData?.result || pData?.body || pData;
      const dData = Array.isArray(fData) ? fData[0] : fData;
      const pNumber = pData?.policy_id || pData?.policy_number || pData?.policy_no || pData?.policyNumber || pData?.PolicyNumber || pData?.PolicyNo || dData?.policy_number || dData?.policy_id || dData?.CertNo || dData?.CertNumber || dData?.certificateNo || dData?.CertificateNo || dData?.certificate_number || dData?.cert_number || dData?.DocumentNo || dData?.DocumentNumber || pData?.policy?.policy_number || pData?.policy?.policy_id || pData?.policy_ref || pData?.policyRef || pData?.policy_reference || pData?.policyReference || dData?.policy_ref || dData?.policyRef || dData?.policy_reference || dData?.policy_reference || pData?.api_response?.policy_number || pData?.api_response?.policy_id || pData?.policy_data?.policy_number || pData?.policy_data?.policy_id || dData?.Policy_Num || dData?.Policy_No || dData?.Pol_No || dData?.PolNo || dData?.policyNo || dData?.policy_ID;

      dispatch(
        updateTransactionData({
          business_status: "PURCHASED",
          payment_status: "success",
          policy_start_date: pData?.travel_dates?.startDate || pData?.policy_start_date || pData?.start_date || null,
          policy_expiry_date: pData?.travel_dates?.endDate || pData?.policy_expiry_date || pData?.end_date || null,
          policy_no: pNumber,
          policy_number: pNumber,
        })
      )

      //productInquiry Data update with user details and policy details
      let productInquiryData = localStorage.getItem("product_inquiry")
        ? JSON.parse(localStorage.getItem("product_inquiry"))
        : null;

      let existingFormData = productInquiryData?.form_data
        ? JSON.parse(productInquiryData?.form_data)
        : {};

      const emailId = existingFormData.email;
      handleSendPdfMail(emailId || 'mohanrajarchunan@gmail.com');
      const discard = [
        "token",
        "api_response",
        "cells",
        "encoded_ins_token",
        "eligiblePlans",
        "planData",
        "start_date",
        "end_date",
      ];
      const filteredPolicyData = Object.keys(policyData).reduce((acc, key) => {
        if (!discard.includes(key)) acc[key] = policyData[key];
        return acc;
      }, {});

      if (productInquiryData) {
        const pData = Array.isArray(policyData) ? policyData[0] : policyData;
        const fData = pData?.data || pData?.api_response || pData?.result || pData?.body || pData;
        const dData = Array.isArray(fData) ? fData[0] : fData;
        const pNumber = pData?.policy_id || pData?.policy_number || pData?.policy_no || pData?.policyNumber || pData?.PolicyNumber || pData?.PolicyNo || dData?.policy_number || dData?.policy_id || dData?.CertNo || dData?.CertNumber || dData?.certificateNo || dData?.CertificateNo || dData?.certificate_number || dData?.cert_number || dData?.DocumentNo || dData?.DocumentNumber || pData?.policy?.policy_number || pData?.policy?.policy_id || pData?.policy_ref || pData?.policyRef || pData?.policy_reference || pData?.policyReference || dData?.policy_ref || dData?.policyRef || dData?.policy_reference || dData?.policy_reference || pData?.api_response?.policy_number || pData?.api_response?.policy_id || pData?.policy_data?.policy_number || pData?.policy_data?.policy_id || dData?.Policy_Num || dData?.Policy_No || dData?.Pol_No || dData?.PolNo || dData?.policyNo || dData?.policy_ID;
        let reqData = {
          id: productInquiryData?.id,
          policy_number: pNumber,
          policy_no: pNumber,
          product_details: {
            product_id: productInquiryData?.product_id,
            sub_product_id: productInquiryData?.sub_product_id,
          },
          form_data: JSON.stringify({
            ...existingFormData,
            ...filteredPolicyData,
            policy_number: pNumber,
          }),
        };
        dispatch(updateProductInquiry(reqData));
      }

      localStorage.removeItem("quoteData");
      localStorage.removeItem("product_inquiry");
      navigate("/policy-download", {
        state: {
          company_name: existingData?.company_name || existingData?.planData?.company_name,
          premium_value: existingData?.premium_value || existingData?.planData?.premium_value,
          premium_currency: existingData?.premium_currency || "OMR",
        },
      });
    }
  }, [policyLoader, policyData, navigate, existingData]);

  const getProductAndCompanyLabel = (data, company_id) => {
    switch (company_id) {
      case 5:
        return data?.plan_name?.replaceAll('*', '') + " - " + data?.company_name;
      default:
        return (
          (product?.productName
            ? product.productName
            : existingData?.planData?.plan_name?.replaceAll('*', '')
              ? existingData.planData.plan_name.replaceAll('*', '')
              : "N/A") +
          " - " +
          (product?.companyName
            ? product.companyName
            : existingData?.planData?.company_name
              ? existingData.planData.company_name
              : "N/A")
        );
    }
  };

  console.log("OmrSymbol =", OmrSymbol);

  if (quoteLoader || policyLoader || PaymentLoader || processingPolicy) {
    return <Loader type="logo-gif" />;
  }
  return (
    <>

      <section className="list-page checkout-page">
        <div className="container" style={{
          justifyItems: 'center'
        }}>


          <div className="row bg-white col-lg-8">


            <div className="col-xl-12 col-lg-12">
              <div className="order_table_box">
                {/* LEFT SIDE — Product Details */}
                <div className="col-lg-6">
                  <div className="product-box">

                    <h2 className="product-title">{t("product")}</h2>
                    <div className="divider"></div>

                    <div className="product-row">
                      <span>
                        {getProductAndCompanyLabel(
                          existingData,
                          existingData?.company_id
                        )}
                      </span>

                      <span className="price-value">
                        {String(existingData?.premium_currency || "OMR")
                          .trim()
                          .toUpperCase() === "OMR" ? (
                          <OmrSymbol width={22} height={22} />
                        ) : (
                          existingData?.premium_currency || "OMR"
                        )}

                        {parseFloat(
                          product?.price ||
                          existingData?.premium_value ||
                          existingData?.planData?.premium_value ||
                          0
                        ).toFixed(3)}
                      </span>
                    </div>

                  </div>
                </div>
                {/* <table className="order_table_detail">
                  <thead className="order_table_head">
                    <tr>
                      <th>Product</th>
                      <th className="right">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="pro__title">
                        {getProductAndCompanyLabel(
                          existingData,
                          existingData?.company_id
                        )}
                      </td>
                      <td className="pro__price">
                        <span className="d-inline-flex align-items-center gap-1">
                          {String(existingData?.premium_currency || "OMR")
                            .trim()
                            .toUpperCase() === "OMR" ? (
                            <OmrSymbol
                              width={22}
                              height={22}
                              style={{
                                display: "inline-block",
                                color: "#000",
                                verticalAlign: "middle",
                              }}
                            />
                          ) : (
                            existingData?.premium_currency || "OMR"
                          )}

                          {parseFloat(product?.price ||
                            existingData?.premium_value ||
                            existingData?.planData?.premium_value ||
                            0).toFixed(3)}
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td className="pro__title">Total</td>
                      <td className="pro__price">
                        <span className="d-inline-flex align-items-center gap-1">
                          {String(existingData?.premium_currency || "OMR")
                            .trim()
                            .toUpperCase() === "OMR" ? (
                            <OmrSymbol
                              width={22}
                              height={22}
                              style={{
                                display: "inline-block",
                                color: "#000",
                                verticalAlign: "middle",
                              }}
                            />
                          ) : (
                            existingData?.premium_currency || "OMR"
                          )}

                          {parseFloat(product?.price ||
                            existingData?.premium_value ||
                            existingData?.planData?.premium_value ||
                            0).toFixed(3)}



                        </span>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan={2}>
                        <div className="d-flex justify-content-end w-100 my-3">
                          <button
                            type="button"
                            className="btn h-btn"
                            onClick={() =>
                              !(quoteLoader || policyLoader || PaymentLoader) &&
                                (product?.price === 0 ||
                                  existingData?.premium_value === 0)
                                ? toast.error(
                                  "The premium value is returned as 0. Can you please try again?"
                                )
                                : proceedToCheckout()
                            }
                          >
                            Proceed To Checkout
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table> */}
              </div>

              {/* RIGHT SIDE — Total + Button */}
              <div className="col-lg-12 justify-i tems-end" style={{
                justifyItems: 'end',
                paddingRight: '48px',
                paddingBottom: '48px'
              }}>
                <div className="total-box">

                  <h4 className="total-label">{t("product_total")}</h4>

                  <div className="total-amount">
                    {String(existingData?.premium_currency || "OMR")
                      .trim()
                      .toUpperCase() === "OMR" ? (
                      <OmrSymbol width={50} height={50} />
                    ) : (
                      existingData?.premium_currency || "OMR"
                    )}

                    <span>
                      {parseFloat(
                        product?.price ||
                        existingData?.premium_value ||
                        existingData?.planData?.premium_value ||
                        0
                      ).toFixed(3)}
                    </span>
                  </div>

                  <button
                    type="button"
                    className="btn h-btn"
                    onClick={() =>
                      !(quoteLoader || policyLoader || PaymentLoader) &&
                        (product?.price === 0 ||
                          existingData?.premium_value === 0)
                        ? toast.error(
                          "The premium value is returned as 0. Can you please try again?"
                        )
                        : proceedToCheckout()
                    }
                  >
                    {t("proceed_checkout")}
                  </button>

                </div>
              </div>
            </div>

            {/* <div className="col-lg-6">
                            <div className="checkout__payment">                                
                                <div className="checkout__payment__item checkout__payment__item--active">
                                    <h3 className="checkout__payment__title">Payment</h3>
                                    <div className="checkout__payment__content">
                                        <form onSubmit={handleFormSubmit} method="POST" >
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Card Number</label>
                                                        <input type="text" className="form-control" id="card-number" name="card_number" placeholder="4444 4444 4444" required onChange={handleInputChange} pattern="\d{16}" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Card Name</label>
                                                        <input type="text" className="form-control" id="card-name" name="card_name" placeholder="Card Name" required onChange={handleInputChange} minLength={3} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Expiry</label>
                                                        <input type="text" className="form-control" id="card-expiry" name="card_expiry" placeholder="08/25" required onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>CVV</label>
                                                        <input type="password" className="form-control" id="card-cvv" name="card_cvv" placeholder="***" required onChange={handleInputChange} pattern="\d{3}" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-right d-flex justify-content-end">
                                                <button type='submit' className="btn h-btn">Pay</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </section>

      <Modal show={attentionAlert} onHide={() => setAttentionAlert(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Attention</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your policy details require manual verification, that will updated
          upto 24 hours and you will be get notified by our team. if you want to
          continue then you need to make an payment.
        </Modal.Body>
        <Modal.Footer>
          <Link to="/company-list">
            <Button type="button" variant="primary">
              Go to company list
            </Button>
          </Link>
          <Button
            type="submit"
            variant="primary"
            onClick={() => setAttentionAlert(false)}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default Checkout;
